<template>
  <div class="flex flex-row items-center p-4" :class="isMe ? 'justify-end': '' ">
    <van-image round class="mr-3" v-if="!isMe" width="40" height="40"
        style="min-width:40px;max-height:40px"
        :src="require('@/assets/icons/v2/icon_assistant_default_avatar.png')"/>
    <div v-if="chatItem.type === 1" class="left-bg">{{ chatItem.content }}</div>
    <div v-if="chatItem.type === 2" class="left-bg" @click="onShowMedia">
      <van-image :src="chatItem.content" width="50vw" height="28vh" fit="contain"/>
    </div>
    <div v-if="chatItem.type === 3" class="left-bg" @click="onShowVideo" >
      <video ref="videoElement" preload="metadata" controls style="width:50vw;height:28vh">
        <source :src="chatItem.content" type="video/mp4">
        Your browser does not support the <code>video</code> element.
      </video>
    </div>
    <van-image v-if="isMe" round class="ml-3" width="40" height="40" :src="chatItem.fromPicture"/>
  </div>
</template>

<script>
export default {
  name: "ChatItem",
  props: {
    chatItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  methods: {
    onShowMedia() {
      this.$emit("onShowMedia", this.chatItem);
    },
    onShowVideo() {
      this.$emit("onShowVideo", this.chatItem);
    }
  },
  computed: {
    isMe() {
      return this.chatItem.isMe === 1;
    }
  },
  mounted() {
    if (this.chatItem.type === 3) {

      // this.$nextTick(() => {
      //   const videoElement = this.$refs.videoElement;
      //   videoElement.addEventListener("loadedmetadata", (e) => {
      //     const canvas = document.createElement("canvas");
      //     videoElement.addEventListener("canplaythrough", () => {
      //       console.log("canplaythrough");
      //       canvas.width = videoElement.videoWidth;
      //       canvas.height = videoElement.videoHeight;
      //       canvas.getContext("2d").drawImage(videoElement, 0, 0, canvas.width, canvas.height);
      //       const firstFrame = canvas.toDataURL();
      //       console.log(firstFrame); // 输出第一帧画面的Base64编码字符串
      //     });
      //   });
      // });
    }
  }
};
</script>

<style scoped lang="less">
.chat-content {
  margin-left: 10px;
}

.left-bg {
  border-top-right-radius: 12px;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  background: white;
  padding: 10px;
}
</style>